import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import LocationMasterService from "../../app/data/door-master/locationMasterService";
import { initialLocationActivityLogState } from "./LocationActivityLogState";

const locationMasterService = LocationMasterService.getInstance();

export const locationActivityLogSlice = createSlice({
    name: "locationActivityLog",
    initialState: initialLocationActivityLogState,
    reducers: {
        resetLocationActivityLog: (state) => initialLocationActivityLogState,
        requestStarted: (state, { payload }) => {
            if (payload === "GET_ACTIVITY_LOGS_PORTION") {
                state.fetchPortionStarted = true;
            } else {
                state.requestStarted = true;
            }
            state.requestSucceed = false;
            state.requestFailed = false;
            state.requestCreator = payload;
            state.requestError = "";
        },
        requestSucceed: (state) => {
            state.requestStarted = false;
            state.fetchPortionStarted = false;
            state.requestSucceed = true;
            state.requestFailed = false;
        },
        requestFailed: (state, { payload }) => {
            state.requestStarted = false;
            state.requestSucceed = false;
            state.requestFailed = true;
            state.requestError = payload;
        },
        setLocationActivityLogRequest: (state, { payload }) => {
            state.locationActivityLogsRequest = {
                page: payload.page,
                last: payload.last
            }
        },
        clearLocationActivityLogList: (state) => {
            state.locationActivityLogs = [];
        },
        setActivityLog: (state, { payload }) => {
            state.locationActivityLogs = payload;
        },
        addActivityLog: (state, { payload }) => {
            state.locationActivityLogs = [...state.locationActivityLogs, ...payload];
        },
        clearActivityLog: (state) => {
            state.locationActivityLogs = [];
        },
        setActivityLogRequest: (state, { payload }) => {
            state.locationActivityLogsRequest = {
                page: payload.page,
                last: payload.last
            }
        },
    }
});

export const {
    requestSucceed,
    requestFailed,
    requestStarted,
    setActivityLog,
    addActivityLog,
    setLocationActivityLogRequest,
    clearLocationActivityLogList,
    clearActivityLog,
    setActivityLogRequest
} = locationActivityLogSlice.actions;

export const locationActivityLogSelector = (state: IState) => state.locationActivityLog;

export const STATIC_LOCATION_ACTIVITY_LOG_ACTION_OPTIONS = [
    { id: "CREATE", name: "CREATE" },
    { id: "UPDATE", name: "UPDATE" },
    { id: "DELETE", name: "DELETE" },
    { id: "DEACTIVATE", name: "DEACTIVATE" },
    { id: "APPROVE", name: "APPROVE" },
    { id: "REJECT", name: "REJECT" }
];

export const getLocationActivityLogList = (
    page?: number,
    search?: any,
    action?: any,
    dateFrom?: any,
    dateTo?: any,
): AppThunk => async (dispatch) => {
    dispatch(requestStarted(page ? "GET_ACTIVITY_LOGS_PORTION" : "GET_ACTIVITY_LOGS"));

    try {
        const response = await locationMasterService.getLocationActivityLogList(
            page,
            search,
            action,
            dateFrom,
            dateTo
        );
        
        dispatch(page ? addActivityLog(response.content) : setActivityLog(response.content));
        dispatch(setActivityLogRequest({
            page: response.pageable.pageNumber,
            last: response.last
        }));
        dispatch(requestSucceed());
    } catch (error: any) {
        dispatch(requestFailed(error?.message || "Error"));
    }
}

const locationActivityLogReducer = locationActivityLogSlice.reducer;
export default locationActivityLogReducer;

